<template>

  <div class="ui grid animated fadeIn">

    <div class="sixteen wide column">

      <div class="ui segment" style="min-height: 150px;">

        <form v-if="quotation.procDate" class="ui form">
          <div class="fields">
            <div class="four wide field">
              <label class="form-label">Data Processamento</label>
              <span>{{ $formatDate(quotation.procDate) }}</span>
            </div>
            <div class="four wide field">
              <label class="form-label">Hora Processamento</label>
              <span>{{ quotation.procTime }}</span>
            </div>            
          </div>
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Observações</label>
              <span>{{ quotation.procComments }}</span>
            </div>
          </div>
        </form>

        <div v-else class="grey text m-t-10">
          <i class="info circle icon"></i> Esse orçamento ainda não foi processado
        </div>

      </div>

    </div>

  </div>

</template>

<script>

  export default {    
    props: ["quotation"],    
  }

</script>